export const truncateStringAndAddEllipsis = (str, maxLength = 50) => {
  if (typeof str !== "string") str = String(str);
  return str.length > maxLength ? str.substring(0, maxLength) + "..." : str;
};
